import * as React from 'react';
import { EmployeeChart } from './EmployeeChart';
import { EmployeeAgencyChart } from './EmployeeAgencyChart';
import MapContainer from '../../Common/MapContainer';
import ZoomHelp from './ZoomHelp';
import { FilterUserState, SpendingReportState } from '../../../interface/MyInterfaces';
import renderHTML from 'react-render-html';
import { isAgg } from '../../Common/Helpers';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { SpendingReportExportLink, getSpendingReportYearLabel } from './SpendingReportButtonHelpers';
import './SpendingReportExport.css';

export class FirstTab extends React.Component<FilterUserState & SpendingReportState, {}> {
    constructor(props) {
        super(props);
    }
    getOverview() {
        //console.log(this.props.UserState);
        if (this.props.UserState !== undefined && this.props.UserState.username !== undefined && this.props.UserState.username !== "" && this.props.UserState.report_display_id !== undefined && this.props.UserState.report_display_id !== "") {
            let logoUni;
            try {
                logoUni = require(`../../../images/univ_logos/${this.props.UserState.report_display_id}.png`);
            }
            catch(err) {

            }
            return (
                <div>
                    <div className="row">
                        <div className="col-md-9">
                            <h1 className="bob">{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.header}</h1>
                            {this.props.UserState.report_display_id == "99007319" && <h2><b style={{ color: "red" }}>Synthetic data for demonstration purposes only</b></h2>}
                            <h3>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.sub_header}</h3>
                        </div>
                        <div className="col-md-3">
                        {logoUni &&
                                <img height='80px' src={String(logoUni)} alt='Logo'></img>
                        }
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            {this.props.UserState.report_display_id == "99007319" ?
                                <p>This report characterizes federal research expenditures at IRIS University and is based on UMETRICS data submitted to IRIS as of October 2018. These are <b style={{ color: "red" }}>synthetic</b> financial and payroll records for the university for fiscal year 2019 <b style={{ color: "red" }}>constructed for purposes of demonstration of the report.</b></p>
                                : <p>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.report_text}</p>}
                            
                        </div>
                    </div>
                </div>
            );
        } else {
            return <i className="fa fa-spinner"></i>;
        }
    }
    getMappedPercent() {
        if (this.props.SpendingReport_Tab1 !== undefined) {
            return this.props.SpendingReport_Tab1.footer_text;
        }
        return <i className="fa fa-spinner"></i>;
    }

    public render() {

        const agg = isAgg(this.props.UserState.report_display_id);
        var chart3_text =this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart3_text && this.props.SpendingReport_Tab1.chart3_text != "" && renderHTML(this.props.SpendingReport_Tab1.chart3_text);
        var chart4_text = this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart4_text && this.props.SpendingReport_Tab1.chart4_text != "" && renderHTML(this.props.SpendingReport_Tab1.chart4_text);
        const isStateAgg = this.props.SpendingReportConf ? this.props.SpendingReportConf.state_fips : 0;
        const yearLabel = getSpendingReportYearLabel(this.props.FilterState.start_year, this.props.FilterState.end_year);
        const isJhuUniversity = this.props.UserState.report_display_id == '14977'
            || this.props.UserState.report_display_id == '32964'
            || this.props.UserState.report_display_id == '57553'
            || this.props.UserState.report_display_id == '76214';
        const chart1ExportReady = isJhuUniversity
            || !!(this.props.SpendingEmployeeChart_Data && this.props.SpendingEmployeeChart_Years);
        const chart2ExportReady = isJhuUniversity
            || !!(this.props.SpendingEmployeeAgencyChart_Data && this.props.SpendingEmployeeAgencyChart !== undefined);
        //console.log(this.props.SpendingReport_Tab1.chart3_text)
        return <div className='firstTab tabcontents container-fluid'>
            {this.getOverview()}
            <div className='row'>
                <div className="col-md-6">
                    <h4>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart1_main_title}</h4>
                    {
                        //JHU
                        (isJhuUniversity
                            || !this.props.SpendingEmployeeChart_Data)
                            ? <div className="chartcontainer spending-chart-export-container">
                                {chart1ExportReady &&
                                    <div className="spending-chart-toolbar spending-chart-toolbar--image">
                                        <SpendingReportExportLink targetId="spending-export-target-1" fileName={`employee-occupation-chart-fy-${yearLabel}.png`} />
                                    </div>}
                                <div id="spending-export-target-1">
                                    <img src={require('../../../images/JHU_chart1.jpg')} alt="JHU_chart1" />
                                </div>
                            </div> :
                            <div className="chartcontainer spending-chart-export-container">
                                <div className="spending-chart-toolbar spending-chart-toolbar--chart1">
                                    {chart1ExportReady &&
                                        <SpendingReportExportLink targetId="spending-export-target-1" fileName={`employee-occupation-chart-fy-${yearLabel}.png`} />}
                                    <ZoomHelp className="zoomhelp chart1" chart_no={1} />
                                </div>
                                <EmployeeChart
                                    refresh_className={"fa fa-refresh refresh"}
                                    normal_or_large={0}
                                    exportTargetId="spending-export-target-1"
                                    SpendingEmployeeChart_Data={this.props.SpendingEmployeeChart_Data}
                                    SpendingEmployeeChart_Years={this.props.SpendingEmployeeChart_Years}
                                    SpendingReport_Tab1={this.props.SpendingReport_Tab1}
                                    SpendingEmployeeChart={this.props.SpendingEmployeeChart}
                                    FilterState={this.props.FilterState}
                                    agg={0} />
                            </div>
                    }
                </div>
                <div className="col-md-6">
                    <h4>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart2_main_title}</h4>
                    {
                        //JHU
                        isJhuUniversity
                            || !this.props.SpendingEmployeeAgencyChart_Data
                            ? <div className="chartcontainer spending-chart-export-container">
                                {chart2ExportReady &&
                                    <div className="spending-chart-toolbar spending-chart-toolbar--image">
                                        <SpendingReportExportLink targetId="spending-export-target-2" fileName={`employee-agency-chart-fy-${yearLabel}.png`} />
                                    </div>}
                                <div id="spending-export-target-2">
                                    <img src={require('../../../images/JHU_chart2.jpg')} alt="JHU_chart2" />
                                </div>
                            </div>
                            :
                            <div className="chartcontainer spending-chart-export-container">
                                <div className="spending-chart-toolbar spending-chart-toolbar--chart2">
                                    {chart2ExportReady &&
                                        <SpendingReportExportLink targetId="spending-export-target-2" fileName={`employee-agency-chart-fy-${yearLabel}.png`} />}
                                    <ZoomHelp className="zoomhelp chart2" chart_no={2} />
                                </div>
                                <EmployeeAgencyChart
                                    normal_or_large={0}
                                    exportTargetId="spending-export-target-2"
                                    SpendingEmployeeAgencyChart_Data={this.props.SpendingEmployeeAgencyChart_Data}
                                    SpendingReport_Tab1={this.props.SpendingReport_Tab1}
                                    SpendingEmployeeAgencyChart={this.props.SpendingEmployeeAgencyChart}
                                    FilterState={this.props.FilterState}
                                    agg={0}
                                    report_display_id={this.props.UserState.report_display_id}
                                />
                            </div>
                    }
                </div>
            </div>
            <div className='row'>
                <div className='col-md-5 load_spending_expenditure_map'>
                    <h4>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart3_main_title}</h4>
                    <div>{chart3_text}</div>
                </div>
                <div className="chartcontainer col-md-7 spending-chart-export-container">
                    <div className="spending-chart-toolbar spending-chart-toolbar--map">
                        <SpendingReportExportLink targetId="spending-export-target-3" fileName={`expenditure-map-national-fy-${yearLabel}.png`} />
                        <ZoomHelp className="zoomhelpmap" chart_no={3} />
                    </div>
                    <div id="spending-export-target-3" className="spending-export-block spending-export-block--map">
                        <h5>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart3_chart_title}</h5>
                        {
                            (this.props.SpendingReportConf && this.props.SpendingExpenditureMap)
                                ? <MapContainer
                                    isInState={false}
                                    isZoomed={false}
                                    isCongress={false}
                                    state_fips={this.props.SpendingReportConf.state_fips}
                                    mapData={this.props.SpendingExpenditureMap}
                                    USState={this.props.USStateList}
                                    agg={agg}
                                />
                                : <div>loading <i className="fa fa-spinner"></i></div>
                        }
                    </div>
                </div>
            </div>
            {agg && (!isStateAgg)? null : //for non-state level aggregate report chart 3 and 4 combined together
                <div className='row'>
                    <div className="chartcontainer col-md-5">
                        <h4>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart4_main_title}</h4>
                        <div>{chart4_text}</div>
                    </div>
                    <div className='col-md-7 chartcontainer spending-chart-export-container'>
                        <div className="spending-chart-toolbar spending-chart-toolbar--map">
                            <SpendingReportExportLink targetId="spending-export-target-4" fileName={`expenditure-map-regional-fy-${yearLabel}.png`} />
                            <ZoomHelp className="zoomhelpmap" chart_no={4} />
                        </div>
                        <div id="spending-export-target-4" className="spending-export-block spending-export-block--map">
                            <h5>{this.props.SpendingReport_Tab1 && this.props.SpendingReport_Tab1.chart4_chart_title}</h5>
                            {
                                (this.props.SpendingReportConf && this.props.SpendingExpenditureMap)
                                    ? <MapContainer
                                        isInState={true}
                                        isZoomed={false}
                                        isCongress={false}
                                        state_fips={this.props.SpendingReportConf.state_fips}
                                        mapData={this.props.SpendingExpenditureMap}
                                        USState={this.props.USStateList}
                                        agg={agg}
                                    />
                                    : <div>loading <i className="fa fa-spinner"></i></div>
                            }
                        </div>
                    </div>
                </div>
                }
            <div className='row'>
                <div className="col-md-12">
                    <p>*Generally, about {this.getMappedPercent()}% of research expenditures can be matched to location information with available data and methodology.</p>
	            </div>
            </div>
        </div >;
    }
}

//export default withUserActionTracker(FirstTab, "Spending Report", "viewed Introductory (First) Tab");